
import Button from "@/components/base/Button"
import JobCard from "@/components/job/card/JobCard"
import Modal from "@/components/base/modal/Modal"
import TextArea from "@/components/base/input/TextArea"
import JobPagePreview from "@/components/job/editor/JobPagePhonePreview"
import ResponseError from "@/components/base/api/ResponseError"

import datesMixin from "@/mixins/dates"
import { routeToBusiness, routeToReview } from "@/helpers/routing"
import { mdiChevronDown } from "@mdi/js"
import {
    getReview,
    STATUS_REJECTED,
    STATUS_PENDING,
    STATUS_APPROVED,
} from "@/services/v2/review.service"
import { API_PENDING } from "@/plugins/api"
import { getJobBySlug } from "@/services/v2/job.service"
import mapping, { jobTypeMapping } from "@/helpers/mapping"
const TYPE = mapping.mapValue(jobTypeMapping)

export default {
    name: "JobReviewCreated",
    components: {
        JobPagePreview,
        Button,
        JobCard,
        Modal,
        TextArea,
        ResponseError,
    },
    mixins: [datesMixin],
    props: {
        message: {
            type: Object,
            required: true,
        },
        isSelf: {
            type: Boolean,
            default: false,
        },
    },
    icons: {
        mdiChevronDown,
    },
    data: () => ({
        routeToBusiness,
        routeToReview,
        feedbackMessage: "",
        reviewRequest: null,
        showPreview: false,
        job: null,
        body: {},
        isExpanded: false,
        isLoading: true,
        error: null,
        review: null,
        isCancelled: false,
    }),
    computed: {
        isUploading() {
            return this.reviewRequest?.state === API_PENDING
        },
        reviewedAt() {
            if (!this.review?.updated_at) return ""
            return this.toDatetime(this.review.updated_at)
        },
        jobType() {
            if (!this.job) return "Job"
            return TYPE(this.job.type?.id || this.job.type_id)
        },
        isAccepted() {
            return this.review?.status === STATUS_APPROVED
        },
        isPending() {
            return this.review?.status === STATUS_PENDING
        },
        isRejected() {
            return this.review?.status === STATUS_REJECTED
        },
    },
    async mounted() {
        this.body = JSON.parse(this.message.body)
        this.job = this.body.params.review.job
        this.fetchReview(this.body.params.review.id)
        this.fetchJob(this.job.slug)
    },
    methods: {
        fetchJob(slug) {
            if (!slug) slug = this.job.slug
            this.$api
                .run(getJobBySlug, slug)
                .then((job) => (this.job = job))
                .catch((err) => {
                    this.error = err
                })
                .finally(() => (this.isLoading = false))
        },
        fetchReview(id) {
            if (!id) return
            this.$api
                .run(getReview, id)
                .then((review) => {
                    this.review = review
                    this.feedbackMessage = review.comment || ""
                })
                .catch((err) => {
                    if (err.status === 404) {
                        this.isCancelled = true
                    }
                    this.error = err
                })
        },
    },
}
